export enum AvcActions {
    GET_ENTRY_STATE = 'PRE-FIBER/AVC/getEntryState',
    SET_LOADING = 'PRE-FIBER/AVC/setAvcLoading',
    SET_ERROR = 'PRE-FIBER/AVC/setAvcError',
    SET_ADDRESS_INPUT = 'PRE-FIBER/AVC/setAddressInput',
    SET_ADDRESS_FORM = 'PRE-FIBER/AVC/setAddressForm',
    SET_ADDRESSES = 'PRE-FIBER/AVC/setAddresses',
    CHECK_ADDRESS = 'PRE-FIBER/AVC/checkAddress',
    RESET_FORM = 'PRE-FIBER/AVC/resetForm',
    SET_ACCESS_SUPPLIER = 'accessSupplier',
    SET_AVAILABILITY_INDICATOR = 'availabilityIndicator',
}

export enum Inputs {
    CITY = 'city',
    STREET = 'street',
    NUMBER = 'number',
}

export const enum FormInputType {
    CONTROL = 'control',
    ELEMENT_BLOCK = 'element_block'
}

export enum ErrorMessage {
    NON_UNIQUE_ADDRESS = 'Not a unique address',
    ADDRESS_NOT_FOUND = 'Address not found',
    TARIFF_ID_NOT_DEFINED = 'Tariff id not defined',
    EMPTY_RESPONSE = 'Empty response',
}
